import { createContext } from "react";
import { MappedEvent, ResultsFormattedTournament } from "@data-types/results";

export const ResultsTournamentContext = createContext(
	{} as ResultsFormattedTournament<Map<string, MappedEvent[]>>
);
